import { defaultAxios } from '@/services/index';

import type { SlackChannelT } from '../../../features/Setting/Integrations/providers/types';

const slackService = {
  async createSlackInfo(code: string, workspaceAlias: string) {
    try {
      const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/slack`,
        {
          code,
        },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async deleteSlackInfo(alias: string, teamId: string) {
    try {
      const res = await defaultAxios.delete(
        `workspaces/${alias}/slack/${teamId}`,
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async fetchSlackChannelList(teamId: string): Promise<SlackChannelT[] | null> {
    // NOTE: This function is to fetch the information of the channels in the Slack workspace
    //       identified by the given teamId *that is currently connected to Syncly*.
    //
    try {
      const res = await defaultAxios.get(`/slack/channel/${teamId}`);
      return res.data;
    } catch (e: any) {
      if (e.response.status === 500) return null;
      console.error(e);
      throw e;
    }
  },
  async joinSlackChannel(
    teamId: string,
    channel_id: string,
    is_private: boolean,
  ) {
    const res = await defaultAxios.post(`/slack/channel/${teamId}`, {
      channel_id,
      is_private,
    });
    return res.data;
  },
  async leaveSlackChannel(
    teamId: string,
    channel_id: string,
    is_private: boolean,
  ) {
    const res = await defaultAxios.patch(`/slack/channel/${teamId}`, {
      channel_id,
      is_private,
    });
    return res.data;
  },
  async setAutoCollect(
    teamId: string,
    channel_id: string,
    is_private: boolean,
  ) {
    const res = await defaultAxios.post(`/slack/channel/${teamId}/auto`, {
      channel_id,
      is_private,
    });
    return res.data;
  },
  async setManualCollect(
    teamId: string,
    channel_id: string,
    is_private: boolean,
  ) {
    const res = await defaultAxios.patch(`/slack/channel/${teamId}/auto`, {
      channel_id,
      is_private,
    });
    return res.data;
  },
};

export default slackService;
